module.exports = __webpack_public_path__ + "21a62804cdacc0cfe5f133de6cec171d.MP3";